import React from "react";
import "./BharatSteel.css"; // 👈 CSS import

const BharatSteelExpo = () => {
  return (
    <div className="BharatSteel">
      <div className="bs-container">
        {/* Logo */}
        <div className="bs-header">
          <img
            src="https://res.cloudinary.com/duxsqzrot/image/upload/v1770712063/WhatsApp_Image_2026-02-09_at_12.50.25_orre0u.jpg"
            alt="AIIFA SteelEx"
            className="bs-logo"
          />
        </div>

        {/* Card */}
        <div className="bs-card">
          <h1 className="bs-title">
            Green Steel Pavilion for the Indian Secondary Steel Sector
          </h1>

          <p className="bs-subtitle">
            AIIFA Cordially Invites you to be part of this landmark initiative
          </p>

          {/* Date + Venue */}
          <div className="bs-tags">
            <span className="bs-tag green">📅 16–17 April 2026</span>

            <span className="bs-tag blue">
              📍 Pavilion- C 13 | Bharat Mandapam, New Delhi
            </span>
          </div>

          <p className="bs-description">
            Join a landmark national platform dedicated to advancing India’s
            transition toward low-carbon and sustainable steel manufacturing.
            Present your organization’s capabilities alongside leading
            producers, policymakers, technology innovators, and global buyers.
          </p>

          {/* 🔷 Event Highlights Images */}
          <div className="bs-images-section">
            <h3 className="bs-section-title">Event Highlights</h3>

            <div className="bs-image-grid">
              <div className="bs-image-card">
                <img
                  src="https://res.cloudinary.com/dxvbzgdgw/image/upload/v1773998134/4a665d77-81bf-4d45-ade8-a57cc73ce045_q2txmj.jpg"
                  alt="Event Highlight 1"
                />
              </div>

              <div className="bs-image-card">
                <img
                  src="https://res.cloudinary.com/dxvbzgdgw/image/upload/v1773998125/a436081f-b2c5-4f8a-adbb-00d7b40264d1_sl2nrh.jpg"
                  alt="Event Highlight 2"
                />
              </div>
            </div>
          </div>

          {/* Why Participate */}
          <div className="bs-section">
            <h3 className="bs-section-title">Why Participate?</h3>

            <div className="bs-grid">
              {[
                "Showcase Leadership in green steel, decarbonization, and energy-efficient manufacturing",
                "Engage Global Markets by connecting with buyers, investors, and technology partners",
                "Collaborate with Policymakers on India’s Net Zero and sustainable growth roadmap",
                "Prepare for the Future with insights on CBAM compliance and green financing opportunities",
                "Enhance Brand Visibility within the national and international steel ecosystem",
              ].map((item, i) => (
                <div key={i} className="bs-card-item">
                  <p>✅ {item}</p>
                </div>
              ))}
            </div>

            <h4 className="bs-footer">
              Be a catalyst in shaping a cleaner, resilient, and globally
              competitive Indian steel industry
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BharatSteelExpo;
